import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";

const uiFont = appThemeFonts.family.ui;

const focusRing = {
  outline: "2px solid #0B5FA5",
  outlineOffset: "2px",
};

export const FieldsStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 15,
});

export const FieldLabel = styled(Typography)({
  display: "block",
  fontFamily: uiFont,
  fontSize: 12,
  fontWeight: 600,
  color: appThemeColors.text.primary,
  marginBottom: 6,
  lineHeight: 1.3,
});

export const RequiredMark = styled("span")({
  color: appThemeColors.semantic.danger,
});

export const CustomerTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "$error",
})(({ $error }) => ({
  fontFamily: uiFont,
  "& .MuiOutlinedInput-root": {
    minHeight: 38,
    borderRadius: 9,
    backgroundColor: appThemeColors.background.paper,
    fontSize: "13.5px",
    fontFamily: uiFont,
    transition: "outline 120ms ease, outline-offset 120ms ease",
    "& fieldset": {
      borderColor: $error
        ? appThemeColors.semantic.danger
        : appThemeColors.border.strong,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: $error
        ? appThemeColors.semantic.danger
        : appThemeColors.text.lightBlue,
    },
    "&.Mui-focused": {
      ...focusRing,
      "& fieldset": {
        borderColor: $error
          ? appThemeColors.semantic.danger
          : appThemeColors.border.strong,
        borderWidth: "1px !important",
      },
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "0 12px",
    height: 38,
    boxSizing: "border-box",
    fontSize: "13.5px",
    fontFamily: uiFont,
    color: appThemeColors.text.primary,
  },
  "& .MuiOutlinedInput-input::placeholder": {
    color: appThemeColors.text.faint,
    opacity: 1,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: 38,
    boxSizing: "border-box",
    padding: "0 12px !important",
    fontSize: "13.5px",
    fontFamily: uiFont,
  },
  "& .MuiSelect-icon": {
    right: 8,
    color: appThemeColors.text.muted,
    fontSize: 16,
  },
  "& .MuiFormHelperText-root": {
    fontFamily: uiFont,
    fontSize: "11.5px",
    marginLeft: 0,
    marginTop: 6,
    color: $error ? appThemeColors.semantic.danger : appThemeColors.text.faint,
  },
}));
